import type { MainViewLayout } from 'components/Layout/MainViewLayout';
import type { ComponentProps } from 'react';
import React from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';

type Props = Pick<
  ComponentProps<typeof MainViewLayout>,
  | 'children'
  | 'summarySection'
  | 'summarySectionActions'
  | 'detailSideBar'
  | 'onDetailSideBarClose'
>;

export const IntegrationSettingsLayout = ({
  children,
  summarySection,
  summarySectionActions,
  detailSideBar,
  onDetailSideBarClose,
}: Props) => (
  <div className="flex flex-col gap-f2 min-w-f0">
    {(summarySection || summarySectionActions) && (
      <div className="flex justify-between items-start gap-f2">
        <div className="min-w-f0">{summarySection}</div>
        {summarySectionActions}
      </div>
    )}
    <div className="flex flex-col gap-f2 min-w-f0">
      <div className="overflow-auto">{children}</div>
      {detailSideBar && (
        <div className="border-t border-main-300 pt-f2">
          <div className="flex justify-end pb-f1">
            <TextButton onClick={onDetailSideBarClose}>
              Close transaction
            </TextButton>
          </div>
          {detailSideBar}
        </div>
      )}
    </div>
  </div>
);
